<div>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid">
      <a href=" " class="navbar-brand">MINI PROJECT</a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              class="nav-link active"
              aria-current="page"
              routerLink="/home"
              routerLinkActive="active"
              >Home</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="/jsonApi"
              routerLinkActive="active"
              >JSON API</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="/github"
              routerLinkActive="active"
              >Git Hub API</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/contact" routerLinkActive="active"
              >Contact Us</a
            >
          </li>
        </ul>
      </div>
    </div>
    >
  </nav>

  <div class="container mt-5">
    <router-outlet></router-outlet>
  </div>
</div>
